var React = require('react');

function StatusOpeningInverted (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Open"),React.createElement("g",{"key":1},[React.createElement("path",{"d":"M11.5,0A11.5,11.5,0,1,0,23,11.5,11.51,11.51,0,0,0,11.5,0","style":{"fill":"#fff","fillRule":"evenodd"},"key":0}),React.createElement("path",{"d":"M16,7.17,9.83,13.89,7.44,11.5a.88.88,0,0,0-1.25,1.25l3.7,3.7,7.38-8.09a.89.89,0,0,0-.06-1.25A.89.89,0,0,0,16,7.17","style":{"fill":"#8bc53f","fillRule":"evenodd"},"key":1})])]);
}

StatusOpeningInverted.defaultProps = {"role":"presentation","viewBox":"0 0 23 23"};

module.exports = StatusOpeningInverted;

StatusOpeningInverted.default = StatusOpeningInverted;
